import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import ImageUploader from 'react-images-upload';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FaEdit, FaRegEye } from 'react-icons/fa';
// core components
import GridItem from '../../../../components/Grid/GridItem';
import GridContainer from '../../../../components/Grid/GridContainer';
import Button from '../../../../components/CustomButtons/Button';
import Card from '../../../../components/Card/Card';
import CardHeader from '../../../../components/Card/CardHeader';
import CardAvatar from '../../../../components/Card/CardAvatar';
import CardBody from '../../../../components/Card/CardBody';
import CardFooter from '../../../../components/Card/CardFooter';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import { getUserById } from './queries';
import { listAllUsers } from '../TableUser/queries';
import { getAllAdmin } from '../../../Admins/TableAdmin/queries';
import { getAllCategories } from '../../../Offer/DetailOffer/queries';
import { updateUserByAdmin, updateCreditLimit, addStoreByAdmin, addOfferByAdmin } from './mutation';
import styles from './style';
import config from '../../../../config';
import { Dialog } from '../../../../components';

const OFFER_SUBJECTS = [
  { value: 'Men', label: 'Men' },
  { value: 'Women', label: 'Women' },
  { value: 'Family', label: 'Family' },
];

const OFFER_WEEK_DAYS = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 0, label: 'Sun' },
];

class Detail extends Component {
  constructor(props) {
    super(props);
    const { detailMerchant } = this.props;
    this.state = {
      edit: false,
      id: detailMerchant ? detailMerchant.id : undefined,
      username: detailMerchant ? detailMerchant.username : '',
      avatarUser: detailMerchant ? detailMerchant.avatarUser : '',
      brandingImage: detailMerchant ? detailMerchant.brandingImage : '',
      brandingName: detailMerchant ? detailMerchant.brandingName : '',
      brandingDetail: detailMerchant ? detailMerchant.brandingDetail : '',
      email: detailMerchant ? detailMerchant.email : '',
      location: detailMerchant ? detailMerchant.location : '',
      telephone: detailMerchant ? detailMerchant.telephone : '',
      firstName: detailMerchant ? detailMerchant.firstName : '',
      lastName: detailMerchant ? detailMerchant.lastName : '',
      prefix: detailMerchant ? detailMerchant.prefix : '',
      suffix: detailMerchant ? detailMerchant.suffix : '',
      taxNumber: detailMerchant ? detailMerchant.taxNumber : '',
      position: detailMerchant ? detailMerchant.position : '',
      stores: detailMerchant ? detailMerchant.stores : [],
      offers: detailMerchant ? detailMerchant.offers : [],
      wallet: detailMerchant ? detailMerchant.wallet : {},
      creditLimit: (detailMerchant && detailMerchant.wallet) ? detailMerchant.wallet.creditLimit : '',
      balanceTDC: 0,
      balanceTDCInfo: (detailMerchant && detailMerchant.wallet) ? detailMerchant.wallet.balanceTDC : 0,
      fileUpLoad: [],
      nameImage: '',
      fileUpLoadBrandingImage: [],
      nameBrandingImage: '',
      open: false,
      titleDialog: '',
      content: '',
      seeMoreStore: false,
      seeMoreOffer: false,
      password: '',
      confirmPassword: '',
      creatingStore: false,
      creatingOffer: false,
      newStoreName: '',
      newStoreLocation: '',
      newStorePhone: '',
      newStoreEmail: '',
      newStoreOpenHour: '09:00',
      newStoreCloseHour: '17:00',
      newStoreTaxRatePercentage: 0,
      newOfferTitle: '',
      newOfferDescription: '',
      newOfferQuantities: 1,
      newOfferPrice: 0,
      newOfferRegularPrice: 0,
      newOfferCategoryId: '',
      newOfferStoreIds: [],
      newOfferStart: '',
      newOfferEnd: '',
      newOfferSubject: [],
      newOfferAvailableDays: [0, 1, 2, 3, 4, 5, 6],
      newOfferStartHour: '09:00',
      newOfferEndHour: '17:00',
      newOfferFiles: [],
      newOfferImageNames: '',
      newOfferTaxRateStore: false,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { detailMerchant } = this.props;
    if (nextProps.detailMerchant !== detailMerchant) {
      const { detailMerchant } = nextProps;
      this.setState({
        id: detailMerchant.id,
        username: detailMerchant.username,
        avatarUser: detailMerchant.avatarUser,
        brandingImage: detailMerchant.brandingImage,
        brandingName: detailMerchant.brandingName,
        brandingDetail: detailMerchant.brandingDetail,
        email: detailMerchant.email,
        location: detailMerchant.location,
        telephone: detailMerchant.telephone,
        firstName: detailMerchant.firstName,
        lastName: detailMerchant.lastName,
        prefix: detailMerchant.prefix,
        suffix: detailMerchant.suffix,
        taxNumber: detailMerchant.taxNumber,
        position: detailMerchant.position,
        stores: detailMerchant.stores,
        offers: detailMerchant.offers,
        wallet: detailMerchant.wallet,
        creditLimit: detailMerchant.wallet.creditLimit,
        balanceTDC: 0,
        balanceTDCInfo: detailMerchant.wallet.balanceTDC
      });
    }
  }

  onEdit = () => {
    const { edit } = this.state;
    // Clear password fields when entering edit mode
    this.setState({ 
      edit: !edit,
      password: '',
      confirmPassword: ''
    });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeNumberOnly = (event) => {
    this.setState({ [event.target.name]: Number.parseInt(event.target.value) });
  }

  handleOfferStoresChange = (event) => {
    const { value } = event.target;
    this.setState({
      newOfferStoreIds: typeof value === 'string' ? value.split(',') : value,
    });
  }

  handleOfferSubjectChange = (event) => {
    const { value } = event.target;
    this.setState({
      newOfferSubject: typeof value === 'string' ? value.split(',') : value,
    });
  }

  handleOfferDayToggle = (dayValue) => {
    const { newOfferAvailableDays } = this.state;
    const isSelected = newOfferAvailableDays.includes(dayValue);
    this.setState({
      newOfferAvailableDays: isSelected
        ? newOfferAvailableDays.filter(day => day !== dayValue)
        : [...newOfferAvailableDays, dayValue],
    });
  }

  handleCheckboxChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  }

  onChooseImage = (images) => {
    this.setState({ fileUpLoad: images, nameImage: images[0].name });
  }

  onChooseBrandingImage = (images) => {
    this.setState({ fileUpLoadBrandingImage: images, nameBrandingImage: images[0].name });
  }

  onSaveProfile = async () => {
    const {
      username, email, location, prefix, suffix, taxNumber, position,
      telephone, firstName, lastName, fileUpLoad, fileUpLoadBrandingImage, brandingName, brandingDetail,
      password, confirmPassword,
    } = this.state;
    let { avatarUser, brandingImage } = this.state;
    const { updateUserByAdmin, match, allAdmins } = this.props;

    // Only validate password if a new password is being set
    if (password) {
      if (password !== confirmPassword) {
        this.setState({
          open: true,
          content: 'Passwords do not match',
          titleDialog: 'Error',
        });
        return;
      }
      if (password.length < 6) {
        this.setState({
          open: true,
          content: 'Password must be at least 6 characters',
          titleDialog: 'Error',
        });
        return;
      }
    }

    if (fileUpLoad.length > 0) {
      const files = Array.from(fileUpLoad);
      const formData = new FormData();
      files.forEach((file, i) => {
        formData.append(i, file);
      });

      await fetch(`${config.upload}`, {
        method: 'POST',
        body: formData,
      })
        .then(res => res.json())
        .then((images) => {
          avatarUser = images.file.uri;
        });
    }
    if (fileUpLoadBrandingImage.length > 0) {
      const files = Array.from(fileUpLoadBrandingImage);
      const formData = new FormData();
      files.forEach((file, i) => {
        formData.append(i, file);
      });

      await fetch(`${config.upload}`, {
        method: 'POST',
        body: formData,
      })
        .then(res => res.json())
        .then((images) => {
          brandingImage = images.file.uri;
        });
    }
    const { id } = match.params;
    
    const currentUsername = localStorage.getItem('username');
    const currentUser = allAdmins && allAdmins.find(admin => admin.username === currentUsername);
    const isAdminUser = currentUser && currentUser.role === 'ADMIN';

    const input = {
      username,
      email, 
      location, telephone, firstName, lastName, avatarUser, id: Number(id), brandingImage, prefix, suffix, taxNumber, position, brandingName, brandingDetail,
    };

    if (isAdminUser && password) {
      input.password = password;
    }

    updateUserByAdmin({
      variables: {
        input,
      },
      refetchQueries: [{ query: getUserById, variables: { id: Number(id) } }, { query: listAllUsers }],
    }).then((res) => {
      console.log('res la gi', res)
      if (res) {
        this.setState({
          fileUpLoad: [], edit: false, open: true, content: 'Completed', titleDialog: 'Update Merchant',
          password: '',
          confirmPassword: '',
        });
      }
    }).catch(({ graphQLErrors }) => {
      console.log('loi o day', graphQLErrors)
      if (graphQLErrors) {
        console.log('loi o day',  graphQLErrors.message)
        this.setState({ open: true, content: graphQLErrors[0].message, titleDialog: 'Erros Update Merchant' });
      }
    });
  }

  onUpdateSetup = () => {
    const { username, creditLimit, balanceTDC } = this.state;
    const { match, updateCreditLimit } = this.props;
    const { id } = match.params;
    updateCreditLimit({
      variables: {
        username,
        creditLimit: parseInt(creditLimit, 0),
        balanceTDC:parseInt(balanceTDC, 0),
      },
      refetchQueries: [{ query: getUserById, variables: { id } }, { query: listAllUsers }],
    }).then((res) => {
      if (res) {
        this.setState({
          fileUpLoad: [], edit: false, open: true, content: 'Completed', titleDialog: 'Update Merchant',
        });
      }
    }).catch(({ graphQLErrors }) => {
      if (graphQLErrors) {
        this.setState({ open: true, content: 'Value invalid', titleDialog: 'Erros Update Merchant' });
      }
    });
  }

  onCreateStore = async () => {
    const {
      id,
      newStoreName,
      newStoreLocation,
      newStorePhone,
      newStoreEmail,
      newStoreOpenHour,
      newStoreCloseHour,
      newStoreTaxRatePercentage
    } = this.state;
    const { addStoreByAdmin } = this.props;

    if (!newStoreName || !newStoreLocation) {
      this.setState({ open: true, content: 'Store name and location are required', titleDialog: 'Create Store' });
      return;
    }

    this.setState({ creatingStore: true });
    try {
      await addStoreByAdmin({
        variables: {
          input: {
            merchantId: Number(id),
            name: newStoreName,
            location: newStoreLocation,
            phone: newStorePhone,
            email: newStoreEmail,
            openHour: newStoreOpenHour,
            closeHour: newStoreCloseHour,
            taxRatePercentage: Number(newStoreTaxRatePercentage) || 0
          }
        },
        refetchQueries: [{ query: getUserById, variables: { id: Number(id) } }]
      });
      this.setState({
        creatingStore: false,
        newStoreName: '',
        newStoreLocation: '',
        newStorePhone: '',
        newStoreEmail: '',
        newStoreOpenHour: '09:00',
        newStoreCloseHour: '17:00',
        newStoreTaxRatePercentage: 0,
        open: true,
        content: 'Store created successfully',
        titleDialog: 'Create Store'
      });
    } catch (error) {
      this.setState({
        creatingStore: false,
        open: true,
        content: (error && error.message) || 'Error creating store',
        titleDialog: 'Create Store'
      });
    }
  }

  onCreateOffer = async () => {
    const {
      id,
      newOfferTitle,
      newOfferDescription,
      newOfferQuantities,
      newOfferPrice,
      newOfferRegularPrice,
      newOfferCategoryId,
      newOfferStoreIds,
      newOfferStart,
      newOfferEnd,
      newOfferSubject,
      newOfferAvailableDays,
      newOfferStartHour,
      newOfferEndHour,
      newOfferFiles,
      newOfferTaxRateStore
    } = this.state;
    const { addOfferByAdmin } = this.props;

    if (
      !newOfferTitle
      || !newOfferDescription
      || !newOfferQuantities
      || !newOfferPrice
      || !newOfferRegularPrice
      || !newOfferCategoryId
      || !newOfferStoreIds
      || !newOfferStoreIds.length
      || !newOfferStart
      || !newOfferEnd
      || !newOfferSubject.length
      || !newOfferAvailableDays.length
      || !newOfferStartHour
      || !newOfferEndHour
    ) {
      this.setState({ open: true, content: 'All offer fields are required', titleDialog: 'Create Offer' });
      return;
    }

    const startDate = new Date(`${newOfferStart}T00:00:00`);
    const endDate = new Date(`${newOfferEnd}T00:00:00`);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (startDate < today) {
      this.setState({
        open: true,
        content: 'Start date must be today or a future date',
        titleDialog: 'Create Offer'
      });
      return;
    }

    if (startDate > endDate) {
      this.setState({
        open: true,
        content: 'Start date cannot be greater than end date',
        titleDialog: 'Create Offer'
      });
      return;
    }

    const offerPriceValue = Number(newOfferPrice) || 0;
    const regularPriceValue = Number(newOfferRegularPrice) || 0;
    if (offerPriceValue > regularPriceValue) {
      this.setState({
        open: true,
        content: 'Offer price cannot be greater than regular price',
        titleDialog: 'Create Offer'
      });
      return;
    }

    const storeIds = newOfferStoreIds
      .map(item => Number(item))
      .filter(item => !Number.isNaN(item));
    if (!storeIds.length) {
      this.setState({
        open: true,
        content: 'You must select at least one store',
        titleDialog: 'Create Offer'
      });
      return;
    }

    const placementTimes = newOfferAvailableDays.map(dayOfWeek => ({
      day_of_week: dayOfWeek,
      start_hour: newOfferStartHour,
      end_hour: newOfferEndHour,
    }));

    this.setState({ creatingOffer: true });
    try {
      let uploadedImages = [];
      if (newOfferFiles && newOfferFiles.length > 0) {
        const files = Array.from(newOfferFiles);
        const formData = new FormData();
        files.forEach((file, i) => {
          formData.append(i, file);
        });

        const uploadResponse = await fetch(`${config.upload}`, {
          method: 'POST',
          body: formData,
        });
        const uploadResult = await uploadResponse.json();

        if (Array.isArray(uploadResult)) {
          uploadedImages = uploadResult.map(img => (img.file ? img.file.uri : img.uri)).filter(Boolean);
        } else if (uploadResult.files && Array.isArray(uploadResult.files)) {
          uploadedImages = uploadResult.files.map(img => (img.file ? img.file.uri : img.uri)).filter(Boolean);
        } else if (uploadResult.file && uploadResult.file.uri) {
          uploadedImages = [uploadResult.file.uri];
        } else if (uploadResult.uri) {
          uploadedImages = [uploadResult.uri];
        }
      }

      await addOfferByAdmin({
        variables: {
          input: {
            merchantId: Number(id),
            title: newOfferTitle,
            description: newOfferDescription,
            quantities: Number(newOfferQuantities) || 0,
            offerPrice: offerPriceValue,
            regularPrice: regularPriceValue,
            categoryId: newOfferCategoryId ? Number(newOfferCategoryId) : null,
            storeIds,
            offerStart: newOfferStart,
            offerEnd: newOfferEnd,
            subject: JSON.stringify(newOfferSubject),
            placementTimes,
            offerTimer: 48,
            images: uploadedImages,
            taxRateStore: newOfferTaxRateStore
          }
        },
        refetchQueries: [{ query: getUserById, variables: { id: Number(id) } }]
      });
      this.setState({
        creatingOffer: false,
        newOfferTitle: '',
        newOfferDescription: '',
        newOfferQuantities: 1,
        newOfferPrice: 0,
        newOfferRegularPrice: 0,
        newOfferCategoryId: '',
        newOfferStoreIds: [],
        newOfferStart: '',
        newOfferEnd: '',
        newOfferSubject: [],
        newOfferAvailableDays: [0, 1, 2, 3, 4, 5, 6],
        newOfferStartHour: '09:00',
        newOfferEndHour: '17:00',
        newOfferFiles: [],
        newOfferImageNames: '',
        newOfferTaxRateStore: false,
        open: true,
        content: 'Offer created successfully',
        titleDialog: 'Create Offer'
      });
    } catch (error) {
      this.setState({
        creatingOffer: false,
        open: true,
        content: (error && error.message) || 'Error creating offer',
        titleDialog: 'Create Offer'
      });
    }
  }

  _renderStore = () => {
    const { classes } = this.props;
    const { stores, seeMoreStore } = this.state;
    return (
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            {
              (stores && stores.length > 0)
                ? <Typography component="p" className={classes.textTitleStores}>Stores</Typography>
                : <Typography component="p" className={classes.textTitleStores}>No Store</Typography>
            }
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            { stores && (
            <GridContainer>
              { !seeMoreStore ? stores.slice(0, 4).map(item => (
                <GridItem xs={12} sm={12} md={3} key={item.id}>
                  <Link to={{ pathname: `/detailStore/${item.id}` }}>
                  <Card profile>
                    <CardAvatar profile>
                      <Avatar alt="Avartar" src={item.pictures || ''} className={classes.avatar} />
                    </CardAvatar>
                    <CardBody profile>
                      <h6 className={classes.cardCategory}>Store</h6>
                      <Typography component="p" className={classes.cardTitle}>{item.name.toUpperCase()}</Typography>
                      <Typography component="p" className={classes.textStore}>{item.location}</Typography>
                      <Typography component="p" className={classes.textStore}>Phone: {item.phone}</Typography>
                    </CardBody>
                  </Card>
                  </Link>
                </GridItem>
              ))
                : stores.map(item => (
                  <GridItem xs={12} sm={12} md={3} key={item.id}>
                      <Link to={{ pathname: `/detailStore/${item.id}` }}>
                    <Card profile>
                      <CardAvatar profile>
                        <Avatar alt="Avartar" src={item.pictures || ''} className={classes.avatar} />
                      </CardAvatar>
                      <CardBody profile>
                        <h6 className={classes.cardCategory}>Store</h6>
                        <Typography component="p" className={classes.cardTitle}>{item.name.toUpperCase()}</Typography>
                        <Typography component="p" className={classes.textStore}>{item.location}</Typography>
                        <Typography component="p" className={classes.textStore}>
                          Phone: {item.phone}
                        </Typography>
                      </CardBody>
                    </Card>
                    </Link>
                  </GridItem>
                ))
                    }
            </GridContainer>
            )
                }
          </GridItem>
          {
            stores.length > 4
              && (
                <GridItem xs={12} sm={12} md={12}>
                  {
                    !seeMoreStore
                      ? <Typography component="p" className={classes.seeMore} onClick={() => this.setState({ seeMoreStore: !seeMoreStore })}>See More</Typography>
                      : <Typography component="p" className={classes.seeMore} onClick={() => this.setState({ seeMoreStore: !seeMoreStore })}>Show Less</Typography>
                  }
                </GridItem>
              )
          }
        </GridContainer>
      </GridItem>
    );
  }

  _renderOffer = () => {
    const { classes } = this.props;
    const { offers, seeMoreOffer } = this.state;
    return (
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            {
              (offers && offers.length > 0)
                ? <Typography component="p" className={classes.textTitleStores}>Offers</Typography>
                : <Typography component="p" className={classes.textTitleStores}>No Offer</Typography>
              }
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            { offers && (
            <GridContainer>
              { !seeMoreOffer ? offers.slice(0, 4).map(item => (
                <GridItem xs={12} sm={12} md={3} key={item.id}>
                  <Link to={{ pathname: `/detailOffer/${item.id}` }}>
                    <Card profile>
                      <CardAvatar profile>
                        <Avatar alt="Avartar" src={item.featureImage || ''} className={classes.avatar} />
                      </CardAvatar>
                      <CardBody profile>
                        <h6 className={classes.cardCategory}>Offer</h6>
                        <Typography component="p" className={classes.cardTitle}>{item.title ? item.title.toUpperCase() : ''}</Typography>
                        <Typography component="p" className={classes.textStore}>{item.saleOff}</Typography>
                        <Typography component="p" className={classes.textStore}>Quantity: {item.quantities}</Typography>
                      </CardBody>
                    </Card>
                  </Link>
                </GridItem>
              ))
                : offers.map(item => (
                  <GridItem xs={12} sm={12} md={3} key={item.id}>
                    <Link to={{ pathname: `/detailOffer/${item.id}` }}>
                      <Card profile>
                        <CardAvatar profile>
                          <Avatar alt="Avartar" src={item.featureImage || ''} className={classes.avatar} />
                        </CardAvatar>
                        <CardBody profile>
                          <h6 className={classes.cardCategory}>Offer</h6>
                          <Typography component="p" className={classes.cardTitle}>{item.title ? item.title.toUpperCase() : ''}</Typography>
                          <Typography component="p" className={classes.textStore}>{item.saleOff}</Typography>
                          <Typography component="p" className={classes.textStore}>
                            Quantity: {item.quantities}
                          </Typography>
                        </CardBody>
                      </Card>
                    </Link>
                  </GridItem>
                ))
                    }
            </GridContainer>
            )
                }
          </GridItem>
          {
            offers.length > 4
              && (
                <GridItem xs={12} sm={12} md={12}>
                  {
                    !seeMoreOffer
                      ? <Typography component="p" className={classes.seeMore} onClick={() => this.setState({ seeMoreOffer: !seeMoreOffer })}>See More</Typography>
                      : <Typography component="p" className={classes.seeMore} onClick={() => this.setState({ seeMoreOffer: !seeMoreOffer })}>Show Less</Typography>
                  }
                </GridItem>
              )
          }
        </GridContainer>
      </GridItem>
    );
  }

  renderCreditLimitIndicator = (detailMerchant, creditLimitValue) => {
    const { classes } = this.props;
    const limit = Math.round(Number(creditLimitValue) || 0);
    const hasPaymentMethod = detailMerchant && detailMerchant.hasPaymentMethod;
    const hasPaymentCustomer = detailMerchant && detailMerchant.hasPaymentCustomer;
    const visibleInApp = hasPaymentCustomer ? limit : 0;
    const isVisible = hasPaymentCustomer;

    let label = `No payment method — merchant sees 0 in app (configured: ${limit})`;
    if (hasPaymentCustomer && hasPaymentMethod) {
      label = `Payment method on file — visible in app (${visibleInApp})`;
    } else if (hasPaymentCustomer && !hasPaymentMethod) {
      label = `Stripe account, no card on file — app may show ${visibleInApp} (configured: ${limit})`;
    }

    return (
      <Typography
        component="span"
        className={`${classes.creditLimitIndicator} ${
          isVisible && hasPaymentMethod
            ? classes.creditLimitIndicatorVisible
            : classes.creditLimitIndicatorHidden
        }`}
      >
        {label}
      </Typography>
    );
  };

  _renderWallet = () => {
    const { classes, loading, detailMerchant } = this.props;
    if (loading) return null;
    const { wallet, id } = this.state;
    const { balance, creditLimit,balanceTDC } = wallet;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardHeader className={classes.headCard}>
              <h4 className={classes.cardTitleWhite}>Wallet And Transactions</h4>
            </CardHeader>
            <CardBody profile>
              <h6 className={classes.cardTitle}>Wallet</h6>
              <p className={classes.description}>
                Balance: {Math.round(balance)}
              </p>
              <p className={classes.description} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <span>Credit Limit: {Math.round(creditLimit)}</span>
                {this.renderCreditLimitIndicator(detailMerchant, creditLimit)}
              </p>
              <p className={classes.description}>
                Transaction DealCoin: {Math.round(balanceTDC)}
              </p>
              <Link to={{ pathname: `/allTransactionMerchant/${id}` }}>
                <Button round className={classes.button}>
                  <Typography component="p" className={classes.text}>View Transactions</Typography>
                  <FaRegEye color="#ffffff" size={16} />
                </Button>
              </Link>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  _renderMerchantUsers = () => {
    const { classes, loading } = this.props;
    if (loading) return null;
    const { id } = this.state;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardHeader className={classes.headCard}>
              <h4 className={classes.cardTitleWhite}>Merchant Users</h4>
            </CardHeader>
            <CardBody profile>
              <p className={classes.description}>
                Manage users associated with this merchant account.
              </p>
              <Link to={{ pathname: `/merchantUsers/${id}` }}>
                <Button round className={classes.button}>
                  <Typography component="p" className={classes.text}>View Users</Typography>
                  <FaRegEye color="#ffffff" size={16} />
                </Button>
              </Link>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  _renderCreditLimit = () => {
    const { classes, loading, detailMerchant } = this.props;
    if (loading) return null;
    const { creditLimit, edit, balanceTDC, balanceTDCInfo } = this.state;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader className={classes.headCard}>
              <h4 className={classes.cardTitleWhite}>{ edit ? 'Edit Setup' : 'Setup User'}</h4>
              { edit ? <p className={classes.cardCategoryWhite}>Complete Setup</p> : null }
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.creditLimitRow}>
                    <div className={classes.creditLimitField}>
                      <CustomInput
                        labelText="Credit Limit"
                        id="creditLimit"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: !edit,
                          value: creditLimit || '',
                          name: 'creditLimit',
                          onChange: this.handleChange,
                          type: 'number',
                        }}
                      />
                    </div>
                    {!edit && this.renderCreditLimitIndicator(detailMerchant, creditLimit)}
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Add or remove transaction DealCoins"
                    id="balanceTDC"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: !edit,
                      value: balanceTDC || 0,
                      name: 'balanceTDC',
                      onChange: this.handleChangeNumberOnly,
                      type: 'number',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Transactions Deal coins available"
                      id="balanceTDCInfo"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: balanceTDCInfo || 0,
                        name: 'balanceTDCInfo',
                      }}
                    />
                </GridItem>
              </GridContainer>
            </CardBody>
            {
                  edit
                    ? (
                      <CardFooter>
                        <Button className={classes.button} onClick={this.onUpdateSetup}>Update Setup</Button>
                      </CardFooter>
                    ) : null
                }
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  _renderTagProfile = () => {
    const { classes, loading } = this.props;
    if (loading) return null;
    const {
      edit, avatarUser, nameImage, username, brandingDetail, brandingName, fileUpLoad,
    } = this.state;
    return (
      <Card profile>
        <CardAvatar profile>
          <Avatar alt="Avartar" src={avatarUser} className={classes.avatar} />
        </CardAvatar>
        {
            edit
              ? (
                <ImageUploader
                  withIcon={false}
                  buttonText="Choose Avatar"
                  label={`New Avatar: ${nameImage}`}
                  withLabel={fileUpLoad.length > 0}
                  onChange={this.onChooseImage}
                  imgExtension={['.jpg', '.gif', '.png', '.gif']}
                  maxFileSize={5242880}
                  fileContainerStyle={styles.uploadImage}
                  buttonStyles={styles.buttonUpload}
                  singleImage
                />
              ) : null
        }
        <CardBody profile>
          <h6 className={classes.cardCategory}>MERCHANT</h6>
          <h4 className={classes.cardTitle}>{username.toUpperCase()}</h4>
          <p className={classes.description}>
            Branding Name: {brandingName.toUpperCase()}
          </p>
          <p className={classes.description}>
            Branding Detail: {brandingDetail.toUpperCase()}
          </p>
          <Button round className={classes.button} onClick={this.onEdit}>
            <Typography component="p" className={classes.text}>{!edit ? 'Edit' : 'Cancel'}</Typography>
            <FaEdit color="#ffffff" size={16} />
          </Button>
        </CardBody>
      </Card>
    );
  }

  _renderCreateActions = () => {
    const { classes, listCategory } = this.props;
    const {
      edit,
      creatingStore,
      creatingOffer,
      newStoreName,
      newStoreLocation,
      newStorePhone,
      newStoreEmail,
      newStoreOpenHour,
      newStoreCloseHour,
      newStoreTaxRatePercentage,
      newOfferTitle,
      newOfferDescription,
      newOfferQuantities,
      newOfferPrice,
      newOfferRegularPrice,
      newOfferCategoryId,
      newOfferStoreIds,
      newOfferStart,
      newOfferEnd,
      newOfferSubject,
      newOfferAvailableDays,
      newOfferStartHour,
      newOfferEndHour,
      newOfferImageNames,
      newOfferTaxRateStore,
      stores
    } = this.state;

    if (!edit) return null;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader className={classes.headCard}>
              <h4 className={classes.cardTitleWhite}>Create Store</h4>
            </CardHeader>
            <CardBody>
              <CustomInput labelText="Name" id="newStoreName" formControlProps={{ fullWidth: true }} inputProps={{ value: newStoreName, name: 'newStoreName', onChange: this.handleChange }} />
              <CustomInput labelText="Location" id="newStoreLocation" formControlProps={{ fullWidth: true }} inputProps={{ value: newStoreLocation, name: 'newStoreLocation', onChange: this.handleChange }} />
              <CustomInput labelText="Phone" id="newStorePhone" formControlProps={{ fullWidth: true }} inputProps={{ value: newStorePhone, name: 'newStorePhone', onChange: this.handleChange }} />
              <CustomInput labelText="Email" id="newStoreEmail" formControlProps={{ fullWidth: true }} inputProps={{ value: newStoreEmail, name: 'newStoreEmail', onChange: this.handleChange }} />
              <CustomInput labelText="Open Hour (HH:mm)" id="newStoreOpenHour" formControlProps={{ fullWidth: true }} inputProps={{ value: newStoreOpenHour, name: 'newStoreOpenHour', onChange: this.handleChange }} />
              <CustomInput labelText="Close Hour (HH:mm)" id="newStoreCloseHour" formControlProps={{ fullWidth: true }} inputProps={{ value: newStoreCloseHour, name: 'newStoreCloseHour', onChange: this.handleChange }} />
              <CustomInput labelText="Tax Rate %" id="newStoreTaxRatePercentage" formControlProps={{ fullWidth: true }} inputProps={{ type: 'number', value: newStoreTaxRatePercentage, name: 'newStoreTaxRatePercentage', onChange: this.handleChange }} />
            </CardBody>
            <CardFooter>
              <Button className={classes.button} onClick={this.onCreateStore} disabled={creatingStore}>{creatingStore ? 'Creating...' : 'Create Store'}</Button>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader className={classes.headCard}>
              <h4 className={classes.cardTitleWhite}>Create Offer</h4>
            </CardHeader>
            <CardBody>
              <CustomInput labelText="Title" id="newOfferTitle" formControlProps={{ fullWidth: true }} inputProps={{ value: newOfferTitle, name: 'newOfferTitle', onChange: this.handleChange }} />
              <CustomInput labelText="Description" id="newOfferDescription" formControlProps={{ fullWidth: true }} inputProps={{ value: newOfferDescription, name: 'newOfferDescription', onChange: this.handleChange }} />
              <CustomInput labelText="Quantities" id="newOfferQuantities" formControlProps={{ fullWidth: true }} inputProps={{ type: 'number', value: newOfferQuantities, name: 'newOfferQuantities', onChange: this.handleChange }} />
              <CustomInput labelText="Offer Price" id="newOfferPrice" formControlProps={{ fullWidth: true }} inputProps={{ type: 'number', value: newOfferPrice, name: 'newOfferPrice', onChange: this.handleChange }} />
              <CustomInput labelText="Regular Price" id="newOfferRegularPrice" formControlProps={{ fullWidth: true }} inputProps={{ type: 'number', value: newOfferRegularPrice, name: 'newOfferRegularPrice', onChange: this.handleChange }} />
              <FormControl fullWidth style={{ marginTop: 16, marginBottom: 8 }}>
                <Typography component="p" style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Category</Typography>
                <Select
                  value={newOfferCategoryId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'newOfferCategoryId',
                    id: 'newOfferCategoryId',
                  }}
                >
                  <MenuItem value="">
                    <em>Select a category</em>
                  </MenuItem>
                  {listCategory && listCategory.length > 0 && listCategory.map(item => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: 16, marginBottom: 8 }}>
                <Typography component="p" style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Stores</Typography>
                <Select
                  multiple
                  value={newOfferStoreIds}
                  onChange={this.handleOfferStoresChange}
                  renderValue={(selected) => {
                    const selectedIds = selected.map(id => Number(id));
                    const selectedStores = stores.filter(store => selectedIds.includes(store.id));
                    return selectedStores.map(store => store.name).join(', ');
                  }}
                >
                  {stores && stores.length > 0 && stores.map(store => (
                    <MenuItem key={store.id} value={store.id}>
                      {store.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: 16, marginBottom: 8 }}>
                <Typography component="p" style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Target Audience</Typography>
                <Select
                  multiple
                  value={newOfferSubject}
                  onChange={this.handleOfferSubjectChange}
                  renderValue={(selected) => {
                    const labels = OFFER_SUBJECTS
                      .filter(item => selected.includes(item.value))
                      .map(item => item.label);
                    return labels.join(', ');
                  }}
                >
                  {OFFER_SUBJECTS.map(item => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography component="p" style={{ fontSize: 12, color: '#666', marginTop: 16, marginBottom: 8 }}>
                Available Days
              </Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 8 }}>
                {OFFER_WEEK_DAYS.map(day => (
                  <FormControlLabel
                    key={day.value}
                    control={(
                      <Checkbox
                        checked={newOfferAvailableDays.includes(day.value)}
                        onChange={() => this.handleOfferDayToggle(day.value)}
                        color="primary"
                      />
                    )}
                    label={day.label}
                  />
                ))}
              </div>
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <TextField
                    label="Start Hour"
                    type="time"
                    value={newOfferStartHour}
                    name="newOfferStartHour"
                    onChange={this.handleChange}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    style={{ marginTop: 8 }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    label="End Hour"
                    type="time"
                    value={newOfferEndHour}
                    name="newOfferEndHour"
                    onChange={this.handleChange}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    style={{ marginTop: 8 }}
                  />
                </GridItem>
              </GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <input
                  accept="image/*"
                  id="newOfferImages"
                  type="file"
                  multiple
                  onChange={(event) => {
                    const files = event.target.files ? Array.from(event.target.files) : [];
                    this.setState({
                      newOfferFiles: files,
                      newOfferImageNames: files.map(file => file.name).join(', ')
                    });
                  }}
                  style={{ marginTop: 12, marginBottom: 8, width: '100%' }}
                />
                <Typography component="p" style={{ fontSize: 12, color: '#666' }}>
                  {newOfferImageNames ? `Selected: ${newOfferImageNames}` : 'You can upload images for this offer'}
                </Typography>
              </GridItem>
              <FormControlLabel
                style={{ marginTop: 8 }}
                control={(
                  <Checkbox
                    checked={newOfferTaxRateStore}
                    onChange={this.handleCheckboxChange}
                    name="newOfferTaxRateStore"
                    color="primary"
                  />
                )}
                label="Taxable offer"
              />
              <TextField
                label="Start Date"
                type="date"
                value={newOfferStart}
                name="newOfferStart"
                onChange={this.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ marginTop: 16 }}
              />
              <TextField
                label="End Date"
                type="date"
                value={newOfferEnd}
                name="newOfferEnd"
                onChange={this.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ marginTop: 16 }}
              />
            </CardBody>
            <CardFooter>
              <Button className={classes.button} onClick={this.onCreateOffer} disabled={creatingOffer}>{creatingOffer ? 'Creating...' : 'Create Offer'}</Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  render() {
    const { classes, loading, allAdmins } = this.props;
    if (loading) return null;
    const {
      edit, username, email, location, prefix, suffix, taxNumber, position, titleDialog, content, open,
      telephone, firstName, lastName, fileUpLoadBrandingImage, nameBrandingImage, brandingImage, brandingName, brandingDetail,
      password, confirmPassword,
    } = this.state;

    const currentUsername = localStorage.getItem('username');
    const currentUser = allAdmins && allAdmins.find(admin => admin.username === currentUsername);
    const canChangePassword = currentUser && currentUser.role === 'ADMIN';

    return (
      <div>
        <GridContainer>
          <Dialog
            title={titleDialog}
            content={content}
            open={open}
            onOk={() => this.setState({ open: false })}
          />
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader className={classes.headCard}>
                <h4 className={classes.cardTitleWhite}>{ edit ? 'Edit Profile' : 'Profile'}</h4>
                { edit ? <p className={classes.cardCategoryWhite}>Complete your profile</p> : null }
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Branding Name"
                      id="brandingName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: brandingName || '',
                        name: 'brandingName',
                        onChange: this.handleChange,
                      }}
                    />
                    <CustomInput
                      labelText="Branding Detail"
                      id="brandingDetail"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: brandingDetail || '',
                        name: 'brandingDetail',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem container justify="center" alignItems="center" xs={12} sm={12} md={6}>
                    <Avatar alt="Brading Image" src={brandingImage || ''} className={classes.bigAvatar} />
                    {
                      edit
                        ? (
                          <ImageUploader
                            withIcon={false}
                            buttonText="Choose Branding Image"
                            label={`New Brangding Image: ${nameBrandingImage}`}
                            withLabel={fileUpLoadBrandingImage.length > 0}
                            onChange={this.onChooseBrandingImage}
                            imgExtension={['.jpg', '.gif', '.png', '.gif']}
                            maxFileSize={5242880}
                            fileContainerStyle={styles.uploadImage}
                            buttonStyles={styles.buttonUpload}
                            singleImage
                          />
                        ) : null
                    }
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Username"
                      id="username"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: username || '',
                        name: 'username',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="First Name"
                      id="firstName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: firstName || '',
                        name: 'firstName',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Last Name"
                      id="lastName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: lastName || '',
                        name: 'lastName',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Prefix"
                      id="prefix"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: prefix || '',
                        name: 'prefix',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Suffix"
                      id="suffix"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: suffix || '',
                        name: 'suffix',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Tax Number"
                      id="taxNumber"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: taxNumber || '',
                        name: 'taxNumber',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Position"
                      id="position"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: position || '',
                        name: 'position',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Email"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: email || '',
                        name: 'email',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Telephone (mobile number)"
                      id="telephone"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: telephone || '',
                        name: 'telephone',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomInput
                      labelText="Location"
                      id="location"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: location || '',
                        name: 'location',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                {edit && canChangePassword && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="New Password"
                        id="password"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'password',
                          disabled: !edit,
                          value: password,
                          name: 'password',
                          onChange: this.handleChange,
                          placeholder: 'Leave empty to keep current password',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Confirm Password"
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'password',
                          disabled: !edit,
                          value: confirmPassword,
                          name: 'confirmPassword',
                          onChange: this.handleChange,
                          placeholder: 'Confirm new password',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                )}
              </CardBody>
              {
                edit
                  ? (
                    <CardFooter>
                      <Button className={classes.button} onClick={this.onSaveProfile}>Update Profile</Button>
                    </CardFooter>
                  ) : null
              }
            </Card>
            {this._renderCreditLimit()}
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            {this._renderTagProfile()}
            {this._renderWallet()}
            {this._renderMerchantUsers()}
          </GridItem>
        </GridContainer>
        {this._renderStore()}
        {this._renderOffer()}
        {this._renderCreateActions()}
      </div>
    );
  }
}

// Mark: default props
Detail.defaultProps = {
  classes: {},
  loading: false,
  detailMerchant: {},
  updateCreditLimit: () => {},
  updateUserByAdmin: () => {},
  addStoreByAdmin: () => {},
  addOfferByAdmin: () => {},
  match: {},
  allAdmins: [],
  listCategory: [],
};

// Mark: PropsType
Detail.propTypes = {
  classes: PropTypes.object,
  loading: PropTypes.bool,
  detailMerchant: PropTypes.object,
  updateCreditLimit: PropTypes.func,
  updateUserByAdmin: PropTypes.func,
  addStoreByAdmin: PropTypes.func,
  addOfferByAdmin: PropTypes.func,
  match: PropTypes.object,
  allAdmins: PropTypes.array,
  listCategory: PropTypes.array,
};
const DetailMerchantById = graphql(getUserById, {
  props: ({ data }) => ({
    loading: data.loading,
    detailMerchant: data.getUserById,
  }),
  options: (props) => {
    return ({ variables: { id: Number(props.match.params.id) }, fetchPolicy: 'cache-and-network' });
  },
});

const AllAdmins = graphql(getAllAdmin, {
  props: ({ data }) => ({
    allAdmins: data.getAllAdmin || [],
  }),
});
const ListCategory = graphql(getAllCategories, {
  props: ({ data }) => ({
    listCategory: data.getAllCategories || [],
  }),
});

const UpdateProfile = graphql(updateUserByAdmin, { name: 'updateUserByAdmin' });
const UpdateCredit = graphql(updateCreditLimit, { name: 'updateCreditLimit' });
const AddStoreByAdmin = graphql(addStoreByAdmin, { name: 'addStoreByAdmin' });
const AddOfferByAdmin = graphql(addOfferByAdmin, { name: 'addOfferByAdmin' });

export default withStyles(styles)(compose(DetailMerchantById, AllAdmins, ListCategory, UpdateProfile, UpdateCredit, AddStoreByAdmin, AddOfferByAdmin)(Detail));
